import React from "react";
import PageTemplate from "./PageTemplate";

const Milestones = () => {
  return (
    <PageTemplate
      title="Prove Your Loyalty. Earn Your Rewards."
      content="Burning isn’t just about reducing supply—it’s about earning your place in history. Milestone NFTs = Proof of your contributions. Exclusive perks = Only for the most committed. Bragging rights = The ultimate prize."
      image="/assets/unlock-milestones.png" // ✅ Changed to .png
    />
  );
};

export default Milestones;
